import axios from 'axios';
import auth from '../configs/auth';

axios.interceptors.request.use(
  function (config) {
    var token = typeof window !== 'undefined' ? window.localStorage.getItem('adminAccessToken') : '';

    let publicPaths = ["/api/v1/otp-generator/generateotp", "/api/v1/otp-generator/verifyOtp",'/api/v1/customer/customerCreate',"/api/v1/country-code-management/get-active-countries","/api/v1/app-theme/get-theme"];
    const isPublicPath = publicPaths.some((path) => config.url.includes(path));
    const isCustomerLookup = config.url.includes("/api/v1/customer/getCustomer");
    if (isPublicPath || (isCustomerLookup && !token)) {
      token = process.env.REACT_APP_PUBLIC_TOKEN
    }
    // get selected jeweller if the user is instalaxmi user
    let selectedJeweller = window.localStorage.getItem(auth.selectedJeweller)
    if(selectedJeweller){
        config.headers["jeweller"] = selectedJeweller;
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const createAxiosResponseInterceptor = async () => {
  const interceptor = axios.interceptors.response.use(
    response => response,
    async error => {
      console.log("error", error)
      const status = error?.response?.status
      console.log("error refresh", status)
      if (!status || (status < 200 || status >= 300) && status !== 401 && status !== 444) {
        console.log("promise reject");
        return Promise.reject(error);
      }

      axios.interceptors.response.eject(interceptor)

      try {
        const refreshToken = window.localStorage.getItem('adminRefreshToken')
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/refreshToken`, { token : refreshToken })

        await saveToken(response);

        error.response.config.headers['Authorization'] = 'Bearer ' + response.data.data.accessToken

        return await axios(error.response.config)
      } catch (error2) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error2);
      } finally {
        console.log("finally")
        createAxiosResponseInterceptor();
      }
    }
  )
}

const saveToken = async res => {
  localStorage.setItem('adminRefreshToken', res.data.data.refreshToken);
  localStorage.setItem('adminAccessToken', res.data.data.accessToken);
  // localStorage.setItem('adminUserData', JSON.stringify(res.data.data.user));
}
